export const common = (action) => {
  const actionName = action.toUpperCase();

  return {
    setValue: (resp) => {
      return {
        type: `SET_${actionName}`,
        resp,
      };
    },
  };
};
